import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { WorkflowApprovalComponent } from 'app/components/client/workflow/forms/workflow/approval/workflow-approval.component';
import { StepperWorkflowComponent } from 'app/components/client/workflow/forms/stepper/stepper-workflow/stepper-workflow.component';
import { ApproversListComponent } from 'app/components/client/workflow/forms/approvers-list/approvers-list.component';
import { ReviewCommentsApprovalHistoryComponent } from 'app/components/client/workflow/forms/review-comments-approval-history/review-comments-approval-history.component';
import { WorkflowReviewHistoryAccordionComponent } from 'app/components/client/workflow/forms/workflow-review-history-accordion/workflow-review-history-accordion.component';
import { AiAnalysisHistoryAccordionComponent } from 'app/components/client/workflow/forms/ai-analysis-history-accordion/ai-analysis-history-accordion.component';
import { MatStepperModule } from '@angular/material/stepper';
import { CommentsComponent } from 'app/components/client/workflow/forms/comments/comments.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadComponent } from 'app/components/client/workflow/forms/purchasing/upload/file-upload.component';
import { WeeklyTimesheetCommentsComponent } from 'app/components/client/workflow/forms/weekly-timesheet-comments/weekly-timesheet-comments.component';
import { GlPostingComponent } from 'app/components/client/workflow/forms/gl-posting/gl-posting.component';
import { AgGridModule } from 'ag-grid-angular';
import { DynamicFormCreateComponent } from 'app/client/workflow/dynamic-form/dynamic-form-create/dynamic-form-create.component';
import { DynamicFormMultipleTypeCreateComponent } from 'app/client/workflow/dynamic-form/dynamic-form-multiple-type-create/dynamic-form-multiple-type-create.component';
import { DynamicFormListComponent } from 'app/client/workflow/dynamic-form/dynamic-form-list/dynamic-form-list.component';
import { AdditionalFieldConfigurationListComponent } from 'app/client/workflow/modules/purchasing/additional-field-configuration-list/additional-field-configuration-list.component';
import { AdditionalFieldConfigurationCreateComponent } from 'app/client/workflow/modules/purchasing/additional-field-configuration-create/additional-field-configuration-create.component';
import { DynamicFormEmbedComponent } from 'app/client/workflow/dynamic-form/dynamic-form-embed/dynamic-form-embed.component';
import { DynamicFormViewOnlyEmbedComponent } from 'app/client/workflow/dynamic-form/dynamic-form-view-only-embed/dynamic-form-view-only-embed.component';
import { ChipModule } from 'primeng/chip';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ClearedBankPaymentComponent } from 'app/components/client/workflow/forms/cleared-bank-payment/cleared-bank-payment.component';
import { FormWatcherComponent } from 'app/components/client/workflow/forms/form-watcher/form-watcher.component';
import { FormPresenceComponent } from 'app/components/client/workflow/forms/form-presence/form-presence.component';
import { VendorChatComponent } from 'app/components/client/workflow/forms/vendor-chat/vendor-chat.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PopoverModule } from 'primeng/popover';
import { TagModule } from 'primeng/tag';
import { StepperModule } from 'primeng/stepper';
import { ButtonModule } from 'primeng/button';
import { BudgetToleranceHistoryAccordionComponent } from 'app/components/client/workflow/forms/budget-tolerance-history-accordion/budget-tolerance-history-accordion.component';
import { BudgetToleranceExceededHistoryComponent } from 'app/components/client/workflow/forms/budget-tolerance-exceeded-history/budget-tolerance-exceeded-history.component';

@NgModule({
	declarations: [
		WorkflowApprovalComponent,
		StepperWorkflowComponent,
		ApproversListComponent,
		ReviewCommentsApprovalHistoryComponent,
		WorkflowReviewHistoryAccordionComponent,
		AiAnalysisHistoryAccordionComponent,
		CommentsComponent,
		FileUploadComponent,
		WeeklyTimesheetCommentsComponent,
		GlPostingComponent,
		DynamicFormCreateComponent,
		DynamicFormMultipleTypeCreateComponent,
		DynamicFormListComponent,
		AdditionalFieldConfigurationListComponent,
		AdditionalFieldConfigurationCreateComponent,
		DynamicFormEmbedComponent,
		DynamicFormViewOnlyEmbedComponent,
		ClearedBankPaymentComponent,
		FormWatcherComponent,
		BudgetToleranceExceededHistoryComponent,
		BudgetToleranceHistoryAccordionComponent,
	],
	imports: [
		StepperModule,
		ButtonModule,
		PopoverModule,
		TagModule,
		CommonModule,
		MatStepperModule,
		FormsModule,
		ReactiveFormsModule,
		AgGridModule,
		RouterModule,
		ChipModule,
		MatChipsModule,
		MatIconModule,
		MatButtonModule,
		MatFormFieldModule,
		FormPresenceComponent,
		VendorChatComponent,
	],
	exports: [
		WorkflowApprovalComponent,
		StepperWorkflowComponent,
		ApproversListComponent,
		ReviewCommentsApprovalHistoryComponent,
		WorkflowReviewHistoryAccordionComponent,
		AiAnalysisHistoryAccordionComponent,
		CommentsComponent,
		FileUploadComponent,
		WeeklyTimesheetCommentsComponent,
		GlPostingComponent,
		DynamicFormCreateComponent,
		DynamicFormMultipleTypeCreateComponent,
		DynamicFormListComponent,
		AdditionalFieldConfigurationListComponent,
		AdditionalFieldConfigurationCreateComponent,
		DynamicFormEmbedComponent,
		DynamicFormViewOnlyEmbedComponent,
		ClearedBankPaymentComponent,
		FormWatcherComponent,
		FormPresenceComponent,
		BudgetToleranceExceededHistoryComponent,
		BudgetToleranceHistoryAccordionComponent,
		VendorChatComponent,
	],
})
export class WorkFlowPluginsModule {}
